import { IApiConfig } from "./abstractions.model";

/**
 * Classe de configuração de APIs na Movida
 */
export class LoganApiConfig implements IApiConfig {
	url: string;
	key: string;

	constructor(other: { url: string, key: string } | LoganApiConfig | string, key?: string) {
		if (typeof other == "string") {
			this.url = other;
			this.key = key ?? "";
		} else {
			this.url = other.url;
			this.key = other.key;
		}
	}
}

